import React, { Suspense } from "react";

const Performance = React.lazy(() => import("@/pages/performance"));

export default function PerformanceContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <Performance />
    </Suspense>
  );
}
